import * as React from 'react';

import {Icon} from '.';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const SwapIcon: React.FC<IconProps> = props => {
  return (
    <Icon viewBox="0 -4 24 25" fill="none" {...props}>
      <Path
        d="M14.8572 7.64286H20.5715V1.92857"
        stroke="#100E3A"
        strokeWidth={2}
      />
      <Path
        d="M20.5715 7.64286C17.3296 3.83334 14.0915 1.92857 10.8572 1.92857C7.62293 1.92857 4.76578 3.07143 2.28578 5.35715M7.42864 11.6429H1.71436V17.3571"
        stroke="#100E3A"
        strokeWidth={2}
      />
      <Path
        d="M1.71436 11.6429C4.95626 15.4524 8.19436 17.3571 11.4286 17.3571C14.6629 17.3571 17.5201 16.2143 20.0001 13.9286"
        stroke="#100E3A"
        strokeWidth={2}
      />
    </Icon>
  );
};

export default SwapIcon;
